import { Language } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Language';
import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const toLanguage = (language: string): Language => {
    return language === 'fr' ? 'fr' : 'en';
  };

  return { language: toLanguage(i18n.language) };
};
